import type { Observer } from '@naturehouse/nh-essentials/lib/architecture/ObserverPattern';
import AbstractSubject from '@naturehouse/nh-essentials/lib/architecture/ObserverPattern';
import { CollectionEvents } from '../../../../common/CollectionBase';
import DescriptionCollection from './DescriptionCollection';
import type { TranslatableContentResponse } from './TranslatableContent';
import { TranslationStorageType } from './TranslatableContent';
import type { iTranslationStorage } from './iTranslationStorage';

export default class DescriptionCollectionStorage
    extends AbstractSubject
    implements Observer, iTranslationStorage
{
    static #instance: DescriptionCollectionStorage | null = null;

    public static getInstance(): DescriptionCollectionStorage {
        if (this.#instance === null) {
            this.#instance = new DescriptionCollectionStorage();
        }

        return this.#instance;
    }

    public static destroyInstance(): void {
        this.#instance = null;
    }

    readonly #collection: DescriptionCollection = DescriptionCollection.getInstance();

    #translationData: TranslatableContentResponse | null = null;

    get translationData(): TranslatableContentResponse | null {
        return this.#translationData;
    }

    private constructor() {
        super();
        this.#collection.attach(this);
    }

    public update(subject: CustomEvent): void {
        if (subject.type !== CollectionEvents.ITEM_RETRIEVED) {
            return;
        }

        this.#translationData = subject.detail.data as TranslatableContentResponse;
        this.#translationData.type = TranslationStorageType.HOUSE_DESCRIPTION;
        this.notify();
    }
}
